
<template>
  <section class="tabbed-selector">
    <div class="tabs" ref="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.value"
        class="tab"
        @click="tabSelected(tab.value)"
        :class="{'selected': selected === tab.value}"
        ref="tabElements"
      >
        <p>{{ $t(tab.label) }}</p>
      </div>
      <div class="border" ref="border"></div>
    </div>
  </section>
</template>

<script>
import { nextTick } from 'vue';

export default {
  name: 'TabbedSelector',
  props: ['selected', 'tabs'],
  methods: {
    tabSelected(value) {
      this.$emit('selected', value);
      this.moveIndicator();
    },
    moveIndicator() {
      nextTick(() => {
        const selectedTab = this.$refs.tabElements.find(tab => tab.classList.contains('selected'));
        const border = this.$refs.border;
        if (selectedTab && border) {
          const tabRect = selectedTab.getBoundingClientRect();
          const tabsRect = this.$refs.tabs.getBoundingClientRect();
          const leftPosition = tabRect.left - tabsRect.left + (tabRect.width / 2) - (border.offsetWidth / 2);
          border.style.width = `${tabRect.width}px`;
          border.style.left = `${leftPosition}px`;
        }
      });
    }
  },
  watch: {
    selected() {
      this.moveIndicator();
    }
  },
  mounted() {
    this.moveIndicator();
  }
}
</script>